import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CONSTANT, LoaderService, OrderService } from '@bst-frontend/shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

export interface PickupPayload {
  pickupLocationId: number | string;
}

@Component({
  selector: 'bst-frontend-delivery-location-modal',
  templateUrl: './delivery-location-modal.component.html',
  styleUrls: ['./delivery-location-modal.component.css'],
})
export class DeliveryLocationModalComponent implements OnInit {
  @Input() orderId!: string; // for save API
  @Input() dataToEdit: any; // pass when editing; otherwise null

  form!: FormGroup;

  @Input() userAddresses: any[] = [];
  @Input() companyAddresses: any[] = [];
  @Input() productData: any = [];
  @Input() orderType: any;
  addressList: any[] = [];
  deliveryLocationOptions: string[] = CONSTANT.deliveryLocationOptions;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private orderService: OrderService,
    private loader: LoaderService
  ) {}

  ngOnInit(): void {
    this.addressList = this.userAddresses;
    if (this.orderType === 'part-load-office') {
      this.addressList = this.companyAddresses;
    }
    this.form = this.fb.group({
      pickupLocationId: [null, Validators.required],
    });

    if (this.dataToEdit) {
      this.setForm(this.convertToPickupPayload(this.dataToEdit));
    }
  }

  convertToPickupPayload(response: any): PickupPayload {
    return {
      pickupLocationId: response.pickup?.address?.addressId || null,
    };
  }

  // ---------- edit mode patch ----------
  private setForm(data: PickupPayload): void {
    this.form.patchValue({ pickupLocationId: data.pickupLocationId });
  }

  private compactAddress(a: any) {
    if (!a) return null;
    const {
      addressId,
      companyName,
      contactName,
      contactNumber,
      pincode,
      city,
      locality,
      buildingName,
      landmark,
      type,
    } = a;
    return {
      addressId,
      companyName,
      contactName,
      contactNumber,
      pincode,
      city,
      locality,
      buildingName,
      landmark,
      type,
    };
  }

  // ---------- payload builder (produces product.subItems object) ----------
  preparePayload() {
    const v = this.form.value as {
      pickupLocationId: string;
    };

    const pickupAddr = this.addressList.find(
      (a) => a.addressId === v.pickupLocationId
    );
    const sharedDelivery = {
      address: this.compactAddress(pickupAddr),
    };

    return { sharedDelivery };
  }

  // ---------- save ----------
  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const payload = this.preparePayload();
    this.loader.show();

    const request$ = this.orderService.updateOrder(this.orderId, payload);

    request$.pipe(finalize(() => this.loader.hide())).subscribe({
      next: (resp) => {
        this.activeModal.close({ status: 'saved', data: resp });
      },
      error: (err) => {
        console.error('Save/update failed', err);
      },
    });
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
